(function() {
	'use strict';

	angular
		.module('pwc.model')
		.service('WinePurchase', WinePurchase);

	WinePurchase.$inject = ['$window', 'BaseModel', 'Transaction'];

	function WinePurchase($window, BaseModel, Transaction) {

		// Entity Defaults
		var defaults = $window.stampit().state({
			"type": "purchase",
			"category": null,
			"price": 0.00,
			"date": new Date(),
			"due": null,
			"arrived": null,
			"note": null,
			"qty": 1,
			"source": null,
			"status": null,
			"total": 0.00
		});

		var WinePurchaseFactory = $window.stampit().enclose(function () {

			this.getSummary = function(){

				var bottles = this.qty + ' bottle' + (this.qty > 1 ? 's ' : ' ');

				if (this.category && this.category.toLowerCase() == 'gift'){
					return 'You were gifted ' + bottles.trim() + (this.source ? ' from ' + this.source : '') + '.';
				}

				var summary = 'You acquired ' + bottles;

				if (this.source){
					summary += 'from ' + this.source + ' ';
				}

				return summary + ' at ' + this.getFormattedCurrency(this.price) + ' per bottle.';
			};

			this.isOnOrder = function(){
				return this.status === 'On Order' ? true : false;
			};

			return $window.stampit.mixIn(this, BaseModel, Transaction);

		});

		return function (properties){
			return $window.stampit.compose(defaults, WinePurchaseFactory).create(properties);
		};

	}

})();
